import { LOGIN_BEGIN, LOGIN_END, SET_USER } from "./types";
import auth from "../api";

export default {
  async login({ commit }, { username, password, rememberMe }) {
    commit(LOGIN_BEGIN);
    try {
      const { data } = await auth.login(username, password, rememberMe);
      commit(SET_USER, data);
    } finally {
      commit(LOGIN_END);
    }
  },
  logout({ commit }) {
    return auth.logout().finally(() => commit(SET_USER, null));
  },
  async init({ commit, getters }) {
    try {
      const { data } = await auth.getUser();
      if (!getters.isAuthenticated) {
        commit(SET_USER, data);
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        commit(SET_USER, null);
      } else {
        throw error;
      }
    }
  },
  async updateUser({ commit }, user) {
    const { data } = await auth.updateUser(user);
    commit(SET_USER, data);
  }
};
